import {NAMES} from "@/scripts/components/ab-data-sheet/ab-data-sheet.constants";
import {ProductTypeEnum} from "@shared/enums";
import {createDomElementHandler} from "@/scripts/utils/dom.utils";

const getCompareAreaEl = (
  productType: ProductTypeEnum
) => {
  const el = createDomElementHandler('div', NAMES.CSS_CLASSES.COMPARE_AREA);

  const ctaOpenClassList = [
    NAMES.CSS_CLASSES.COMPARE_BOX_CTA,
    NAMES.CSS_CLASSES.TRIGGER_SHOW_COMPARE_BOX
  ];
  const ctaOpen = createDomElementHandler('span', ctaOpenClassList);
  ctaOpen.textContent = `Aggiungi ${productType === ProductTypeEnum.OBIETTIVO ? 'obiettivo' : 'fotocamera'} al confronto`;

  const ctaCloseClassList = [
    NAMES.CSS_CLASSES.COMPARE_BOX_CTA,
    NAMES.CSS_CLASSES.TRIGGER_HIDE_COMPARE_BOX
  ];

  const ctaClose = createDomElementHandler('span', ctaCloseClassList);
  ctaClose.textContent = `Chiudi Pannello`;

  const instruction = createDomElementHandler('p', NAMES.CSS_CLASSES.COMPARE_BOX_INSTRUCTION);
  instruction.textContent = `Cerca il nome del modello che vuoi aggiungere al confronto o scegli fra tutti quelli disponibili`;

  el.append(ctaClose, instruction, ctaOpen);
  return el;
}

export { getCompareAreaEl }